import { LightstreamerClient } from "lightstreamer-client-web";
import * as types from "../constants/activityConstants";
import { CommonActions } from "./commonActions";
import { LSPATH } from "../constants";
import { Subscription } from "lightstreamer-client-web";
import * as activitType from "../constants/activityConstants";
import appConstants from "../appConstants";
import * as commonType from "../constants/commonConstants";


const ADAPTER_NAME = "NOTIFICATIONS";
const ADAPTER_SET = "FORWARDS";
const SUB_MODE = "MERGE";
const SNAPSHOT_REQ = "yes";
const notificationStream = new Map();
const streamName = "notification";

export function adduserLogInActivity() {
  const user = JSON.parse(localStorage.getItem("user"));
  var msg = {
    BCM: "7",
    MSG: user.name + " logged in.",
  };
  return {
    type: types.ADD_ACTIVITYCOMPONENT,
    msg,
  };
}
export function loadActivityComponent() {
  return {
    types: types.LOAD_ACTIVITYCOMPONENT,
  };
}
export function closeOrdConfirmMsg() {
  return {
    type: types.UPDATE_ORDCNFMSG,
  };
}
export function closeDealConfirmMsg() {
  return {
    type: types.ClOSE_DEALCNFMSG,
  };
}
export function closeBmkConfirmMsg() {
  return {
    type: types.ClOSE_BMKCNFMSG,
  };
}
export function resetState() {
  return {
    type: types.RESET_STATE,
  };
}
export function closeBMAlert(benmFillObj) {
  return {
    type: types.CLOSE_BM_MODAL,
    benmFillObj,
  };
}
export function closeReqRejectModal(requestRejectModal) {
  return {
    type: types.CLOSE_REQ_REJECTED_MODAL,
    requestRejectModal,
  };
}
//modify order CTID
export function setOrdersCTID(ctid) {
  return {
    type: types.GET_ORDERS_CTID,
    ctid,
  };
}

//trde CTID
export function setTrdCTID(ctid) {
  return {
    type: types.GET_TRADE_CTID,
    ctid,
  };
}

//dealFailed flag
export function closeDealFailedModal(flag) {
  return {
    type: types.DEAL_FAILED_FLAG,
    flag,
  };
}
//bmFailed flag
export function closeBMFailedModal(flag) {
  return {
    type: types.BM_FAILED_FLAG,
    flag,
  };
}

//clearNotifications
export function clearNotifications(flag) {
  return {
    type: types.CLEAR_NOTIFICATION_FLAG,
    flag,
  };
}

//setNotificaton counter when add or close notification
export function setNotificationCounter(cnt) {
  return {
    type: types.SET_NOTIFICATION_COUNTER,
    cnt,
  };
}

//close payment req reject modal
export function closePayReqRejectModal(reqData) {
  return {
    type: types.CLOSE_PAY_REQ_REJECTED_MODAL,
    reqData,
  };
}

//order placed from dashbord trading widget
export function setLimitOrderFlag(flag) {
  return {
    type: types.SET_LMT_ORD_FLAG,
    flag,
  };
}

//bmk order placed from dashbord trading widget
export function setBmkOrderFlag(flag) {
  return {
    type: types.SET_BMK_ORD_FLAG,
    flag,
  };
}

//stop order placed from dashbord trading widget
export function setStopOrderFlag(flag) {
  return {
    type: types.SET_STOP_ORD_FLAG,
    flag,
  };
}

//reset updated avg bmk flag
export function resetIsAvgBMKUpdated(flag) {
  return { type: types.RESET_IS_AVG_BMK_UPDATED, flag };
}

export function getAvgBMKDrilldownData(requestBody) {
  return (dispatch) => {
    promise: dispatch(
      CommonActions.handleAPICall(
        requestBody,
        "/GetAvgDetBMKTRD",
        types.GET_AVG_BMK_DRILLDOWN_DATA,
        "POST"
      )
    );
  };
}
// update value date for mkt orders
export function updateMktOrderVD() {
  return { type: types.UPDATE_VD };
}

export function displayModal(value) {
  return { type: types.DISPLAY_MODAL, value };
}

export function selectOrdersAll(orders) {
  return { type: types.SELECT_ORDERS_ALL, orders };
}

/**
 * Generates an activity log message for forward trade. 
 * @param msg - The object that is needed to generate activity log message. 
 * @param isFwdFlag - Flag to identify whether it's a forward trade.
 * @returns action object that includes the message data and a type for updating the activity log widget. 
 */

export function actLogRmkGenerator(msg, isFwdFlag = false) {
  return {
    type: activitType.UPDATE_ACTIVITYCOMPONENT,
    msg, 
    isFwdFlag
  };
}

export function forwardSettingChange(msg) {
  try {
    var TS = {};
    TS = JSON.parse(localStorage.getItem("TS"));
    TS.ACD = [msg];
    localStorage.setItem("TS", JSON.stringify(TS));
    return {
      type: commonType.FORCED_LOGOUT,
    };
  } catch (e) {
    console.log(e);
  }
}


/**
 * Connect to notification stream
 * @returns redux action for notification stream connection
 */

export function connectNotificationStream() {
  return (dispatch) => {
    const client = new LightstreamerClient(LSPATH, ADAPTER_SET);
    const USER = JSON.parse(localStorage.getItem("user"));
    const PLATFORM = localStorage.getItem("platform");
    const UID = USER?.id;
    const SESSIONID = USER?.sid;
    const username = USER?.location;
    const password = `${UID}##${PLATFORM}`;
    client.connectionDetails.setUser(username);
    client.connectionDetails.setPassword(password);
    const subFieldName = "DATA";
    const traderAccounts = JSON.parse(localStorage.getItem('traderAccounts'));
    const subItemName = `${UID}~${traderAccounts}~${PLATFORM}~${SESSIONID}`;
    const subscriptionObj = new Subscription(SUB_MODE);
    subscriptionObj.setDataAdapter(ADAPTER_NAME);
    subscriptionObj.setRequestedSnapshot(SNAPSHOT_REQ);
    subscriptionObj.setItems([subItemName]);
    subscriptionObj.setFields([subFieldName]);
    subscriptionObj.addListener({
        onItemUpdate: (msg) => {
          const msgData = JSON.parse(msg.getValue("DATA"))
          if(msgData) {
            dispatch(actLogRmkGenerator(msgData, true));
          }
          if(msgData.BCM === appConstants.FORWARD_SETTING_CHANGED) {
            dispatch(forwardSettingChange(msgData));
          }
        },
    });
    client.subscribe(subscriptionObj);
    client.connect();
    const subscriptionDetails = {
      client,
      subscriptionObj,
    };
    notificationStream.set(streamName, subscriptionDetails);
    return {
      type: types.LS_NOTIFICATION_CONN,
      payload: subscriptionObj,
    };
  };
}

/**
 * Close notification stream
 * Unsubscribe and disconnect stream
 * @returns redux action for closing notification stream connection
 */
export function disconnectNotificationStream() {
  const { client, subscriptionObj } = notificationStream.get(streamName);
  client.unsubscribe(subscriptionObj);
  client.disconnect();
  return {
    type: types.CLOSE_LS_NOTIFICATION_CONN,
  };
}
